import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';


const HoverMask = styled.div`
  display: none;
  pointer-events: none;
  position: absolute;
  top: 0px;right: 0px; bottom: 0px;left: 0px;
  opacity: 0.3;
`;

const OutlineMask = styled(HoverMask)`
  background-color: ${props => props.color};
`;

const ContainerMask = styled(HoverMask)`
`;

const CommonContainer = styled.div`
  position: relative;
  height: 40px;
  padding: 0px 16px;
  border: none;
  border-radius: 2px;
  outline: none;
  transition: all 0.2s ease 0s;
  cursor: pointer;
  font-family: inherit;
  font-weight: 300;
  display: flex;
  align-items: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  justify-content: center;
  ${props => props.disabled && `opacity: 0.5; cursor: default;`}


`;

const Container = styled(CommonContainer)`
  color: ${props => props.textColor};
  background-color: ${props => props.color};


  ${props => !props.disabled && `
    :hover {
      ${ContainerMask} {
        display: block;
      }
    }
    :active {
      color: white;
      background-color: #626469;
    }
  `}
}
`;

const OutlineContainer = styled(CommonContainer)`
  border-width: 1px;
  border-style: solid;
  border-image: initial;
  background-color: transparent;
  color: ${props => props.color};
  border-color: ${props => props.color};

  ${props => !props.disabled && `
    :hover {
      ${OutlineMask} {
        display: block;
      }
    }
  `}
`;

const ButtonText = styled.span`
  font-size: 16px;
`;

class SurveyButton  extends React.Component {

  static propTypes = {
    text: PropTypes.string,
    color: PropTypes.string,
    textColor: PropTypes.string,
    outline: PropTypes.bool,
    callback: PropTypes.func,
    disabled: PropTypes.bool,
  }

  renderContent  = () => {
    return (<ButtonText>{this.props.text}</ButtonText>);
  }

  render = () => {
    return this.props.outline ?
    <OutlineContainer disabled={this.props.disabled} color={this.props.color} onClick={() => { if (!this.props.disabled) { this.props.callback(); }}}>
      {this.renderContent()}
      <OutlineMask color={this.props.color}></OutlineMask>
      </OutlineContainer> :
    <Container disabled={this.props.disabled} color={this.props.color} textColor={this.props.textColor} onClick={() => { if (!this.props.disabled) { this.props.callback(); }}}>
      {this.renderContent()}
      <ContainerMask></ContainerMask>
      </Container>;
  }
}
export default SurveyButton;
